import React from 'react';
import PatientFormTemplate from '../components/PatientFormTemplate';

export default function PatientPHQ9Form() {
    return (
        <PatientFormTemplate formTitle="Patient Health Questionnaire (PHQ-9)" />
    );
}
